import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from './material/material.module';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxMaskModule } from 'ngx-mask';
import { ServicesModule } from './services/services.module';
import { SnackbarComponent } from './snackbar/snackbar.component';
import { BottomSheetComponent } from './bottom-sheet/bottom-sheet.component';
import { LayoutModule } from './layout/layout.module';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { DragScrollModule } from 'ngx-drag-scroll';
import { AuthGuardService } from '../guards/auth-guard.service';
import { BlockPasteDirective } from './directives/block-paste.directive';
import { NgxQRCodeModule } from '@techiediaries/ngx-qrcode';
import { ServiceButtonComponent } from './service-button/service-button.component';
import { WaitlistModalComponent } from './waitlist-modal/waitlist-modal.component';
import { WatchlistModalComponent } from './watchlist-modal/watchlist-modal.component';
import { ScheduleContactModalComponent } from './schedule-contact-modal/schedule-contact-modal.component';
import { RateModalComponent } from './rate-modal/rate-modal.component';
import { RecommendedProductsComponent } from './recommended-products/recommended-products.component';
import { ClickStopPropagation } from './directives/stop-propagation.directive';
import { SimpleContactModalComponent } from './simple-contact-modal/simple-contact-modal.component';
import { MaskValueDirective } from './directives/mask-value.directive';

@NgModule({
    declarations: [
        SnackbarComponent,
        BottomSheetComponent,
        BlockPasteDirective,
        ServiceButtonComponent,
        WaitlistModalComponent,
        WatchlistModalComponent,
        ScheduleContactModalComponent,
        RateModalComponent,
        RecommendedProductsComponent,
        ClickStopPropagation,
        SimpleContactModalComponent,
        MaskValueDirective
    ],
    imports: [
        CommonModule,
        MaterialModule,
        RouterModule,
        TranslateModule,
        NgxMaskModule.forChild(),
        ServicesModule,
        ReactiveFormsModule,
        LayoutModule,
        NgxQRCodeModule,
        CarouselModule,
        DragScrollModule
    ],
    exports: [
        MaterialModule,
        RouterModule,
        TranslateModule,
        ServicesModule,
        SnackbarComponent,
        BottomSheetComponent,
        ReactiveFormsModule,
        LayoutModule,
        CarouselModule,
        DragScrollModule,
        BlockPasteDirective,
        ServiceButtonComponent,
        WaitlistModalComponent,
        WatchlistModalComponent,
        RateModalComponent,
        RecommendedProductsComponent,
        ClickStopPropagation,
        SimpleContactModalComponent,
        MaskValueDirective
    ],
    providers: [
        SnackbarComponent,
        AuthGuardService,
    ]
})
export class SharedModule { }
